export default "__VITE_ASSET__DyFn2fOS__"